export default __webpack_public_path__ + "static/media/0111.cc48db75.png";